// Keep the existing FAB, but never place it over product information or controls.
const fab = document.getElementById('sdr-wa-fab');
if (fab) {
  const scroller = document.querySelector('.page-wrapper');
  let pending = false;
  const intersects = (a, b) => a.left < b.right + 6 && a.right > b.left - 6 && a.top < b.bottom + 6 && a.bottom > b.top - 6;
  function update() {
    pending = false;
    // Layout offsets do not shrink with the hidden state's transform: no oscillation.
    const r = { left: fab.offsetLeft, top: fab.offsetTop, right: fab.offsetLeft + fab.offsetWidth, bottom: fab.offsetTop + fab.offsetHeight };
    const protectedAreas = document.querySelectorAll('.sdr-pdp__info, .sdr-pdp__arrow, .sdr-pdp__thumbs, .sdr-cc__info, .sdr-pc__info, .sdr-club-announcement, .sdr-club-card, footer');
    const blocked = [...protectedAreas].find(e => e.checkVisibility() && intersects(r, e.getBoundingClientRect()));
    const modal = document.querySelector('dialog[open],#Details-menu-drawer-container[open]');
    const visible = Math.max(window.scrollY, scroller?.scrollTop || 0) > 280 && !blocked && !modal;
    if (!visible && document.activeElement === fab && blocked) {
      const next = [...blocked.querySelectorAll('a[href],button,summary')].find(e => {
        const p = e.getBoundingClientRect();
        return e.checkVisibility() && p.top >= 0 && p.bottom <= innerHeight;
      });
      if (next) next.focus({ preventScroll: true });
      else {
        const previous = blocked.getAttribute('tabindex');
        blocked.tabIndex = -1;
        blocked.focus({ preventScroll: true });
        blocked.addEventListener('blur', () => previous === null ? blocked.removeAttribute('tabindex') : blocked.setAttribute('tabindex', previous), { once: true });
      }
    }
    fab.classList.toggle('sdr-wa-fab--obscured', !!blocked || !!modal);
    fab.classList.toggle('sdr-wa-fab--visible', visible);
    fab.inert = !visible;
    fab.setAttribute('aria-hidden', String(!visible));
  }
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  new MutationObserver(schedule).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open', 'hidden'] });
  document.fonts.ready.then(schedule);
  schedule();
}
